import React from "react";
import heroImage from "assests/About/awards/banner.jpg";
import Container from "Components/Container/Container";
import SocialMedia from "Pages/Home/Hero/SocialMedia/SocialMedia";

const Hero = ({ data }) => {
  return (
    <section className="scroll-section pt-36 pb-8 lg:h-[100vh] relative">
      <img
        className="absolute w-[100vw] left-0 top-0 h-[100vh] object-cover z-[0]"
        src={heroImage}
        alt=""
      />
      <Container className={`relative z-[10] h-full flex justify-between `}>
        <div className="h-full  flex-1 flex flex-col justify-center items-center">
          {/* <p className="text-3xl text-white mb-4 uppercase font-medium text-gray-400">
            {data?.title}
          </p> */}

          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl text-white bebas uppercase text-center mb-[6rem]"
            dangerouslySetInnerHTML={{ __html: data?.sub_title }}
          />
        </div>
        <SocialMedia />
      </Container>
    </section>
  );
};

export default Hero;
